import type { ProfileTab } from '../../utils/navigationHelpers.ts'
import { QUERY_PARAM_TO_TAB } from '../../utils/navigationHelpers.ts'

export interface ProfileTabPrompt {
  label: string
  prompt: string
}

export const PROFILE_TAB_PROMPTS: Partial<
  Record<ProfileTab, { own: ProfileTabPrompt; other: ProfileTabPrompt }>
> = {
  resumen: {
    own: {
      label: 'Resumen',
      prompt: '¿Cómo puedo mejorar mi perfil en Edify?'
    },
    other: {
      label: 'Resumen',
      prompt: '¿Qué información puedo ver de los perfiles de los profesionales o empresas?'
    }
  },
  productos: {
    own: {
      label: 'Productos/Servicios',
      prompt: '¿Cómo puedo crear y promocionar mis productos o servicios?'
    },
    other: {
      label: 'Productos/Servicios',
      prompt: '¿Me ayudás a explorar los productos y servicios de los profesionales o empresas?'
    }
  },
  calificaciones: {
    own: {
      label: 'Calificaciones',
      prompt: '¿Cómo puedo conseguir más calificaciones?'
    },
    other: {
      label: 'Calificaciones',
      prompt: '¿Cómo calificar a los profesionales o empresas?'
    }
  },
  proyectos: {
    own: {
      label: 'Proyectos publicados',
      prompt: '¿Me ayudás a promocionar mis proyectos publicados?'
    },
    other: {
      label: 'Proyectos publicados',
      prompt: '¿Qué información puedo ver de los proyectos publicados de los profesionales o empresas?'
    }
  },
  cotizaciones: {
    own: {
      label: 'Cotización de materiales',
      prompt: '¿Cómo gestionar mejor mis cotizaciones de materiales?'
    },
    other: {
      label: 'Cotización de materiales',
      prompt: '¿Qué información puedo ver de las cotizaciones de materiales de los profesionales o empresas?'
    }
  },
  documentaciones: {
    own: {
      label: 'Documentaciones de obra',
      prompt: '¿Me ayudás con las documentaciones de obra?'
    },
    other: {
      label: 'Documentaciones de obra',
      prompt: '¿Qué información puedo ver de las documentaciones de obra de los profesionales o empresas?'
    }
  },
  accesos: {
    own: {
      label: 'Accesos a obras',
      prompt: '¿Me ayudás con los accesos solicitados a obras?'
    },
    other: {
      label: 'Perfil',
      prompt: '¿Me ayudás con la información de este perfil?'
    }
  }
}

const PROFILE_GENERIC = {
  own: { label: 'Perfil', prompt: '¿Cómo puedo aprovechar mejor mi perfil en Edify?' },
  other: { label: 'Perfil', prompt: '¿Qué información puedo ver de los perfiles de los profesionales o empresas?' }
}

export function getProfileContextualSuggestion(
  tabParam: string | null,
  isOwnProfile: boolean
): ProfileTabPrompt | null {
  if (!tabParam) return PROFILE_GENERIC[isOwnProfile ? 'own' : 'other']
  const tab = tabParam.trim().toLowerCase() as ProfileTab
  const tabConfig = PROFILE_TAB_PROMPTS[tab]
  if (!tabConfig) return PROFILE_GENERIC[isOwnProfile ? 'own' : 'other']
  const variant = isOwnProfile ? tabConfig.own : tabConfig.other
  return variant
}

export function getTabLabel(tabParam: string | null): string {
  if (!tabParam) return 'Perfil'
  const tab = tabParam.trim().toLowerCase() as ProfileTab
  return QUERY_PARAM_TO_TAB[tab] ?? 'Perfil'
}
